import s from './StatsBar.module.scss';

function StatCard({ label, value, sub, accent }) {
    return (
        <div className={`${s.card} ${accent ? s[accent] : ''}`}>
            <div className={s.value}>{value ?? '—'}</div>
            <div className={s.label}>{label}</div>
            {sub && <div className={s.sub}>{sub}</div>}
        </div>
    );
}

export default function StatsBar({ stats }) {
    if (!stats) {
        return (
            <div className={s.bar}>
                {[...Array(5)].map((_, i) => <div key={i} className={`${s.card} ${s.skeleton}`} />)}
            </div>
        );
    }

    return (
        <div className={s.bar}>
            <StatCard label="Всего порталов" value={stats.total_portals} sub={`${stats.installed_portals} установлено`} />
            <StatCard label="Платные подписки" value={stats.paying_portals} accent="blue" />
            <StatCard label="Триал подписки" value={stats.trial_portals} accent="amber" />
            <StatCard label="AI-запросов за 30 дней" value={stats.total_ai_calls_last_month.toLocaleString('ru-RU')} accent="purple" />
            <StatCard label="Токенов расширения" value={stats.total_extension_tokens} accent="green" />
        </div>
    );
}
